<template>
  <div
    id="search-box"
    class="header-filter search-area collapse"
    :class="{ show: opened }"
  >
    <form class="search-item-box" autocomplete="off" action="/action_page.php">
      <div class="autocomplete">
        <span class="icon"><i class="fa fa-search"></i></span>
        <input
          id="myInput"
          type="text"
          name="myCountry"
          placeholder="Поиск по сайту"
        />
        <button
          class="btn btn-close collapsed"
          type="button"
          data-toggle="collapse"
          data-target=".search-area"
          aria-expanded="false"
          aria-controls="search-box"
          @click="$emit('close')"
        >
          Найти
        </button>
        <ul class="suggest_results">
          <!-- <li><a href="#">Ключевое слово 1</a></li>
          <li><a href="#">Ключевое слово 2</a></li>
          <li><a href="#">Ключевое слово 3</a></li>
          <li><a href="#">Ключевое слово 4</a></li>
          <li><a href="#">Ключевое слово 5</a></li>
          <li><a href="#">Ключевое слово 6</a></li> -->
        </ul>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },
  },
}
</script>

<style lang="scss">
/*the container must be positioned relative:*/
.header-filter {
  position: absolute;
  display: block;
  background-color: #000;
  width: calc(100% + 90px);
  top: -5px;
  left: 0;
  z-index: 2;
  transform: translateX(0);

  @media (max-width: 1199px) {
    width: calc(100% + 110px);
    top: -22px;
  }
  @media (max-width: 991px) {
    width: 100%;
    padding: 10px 0;
    padding-left: 10px;
    border-radius: 0px 0px 6px 6px;
    top: 12px;
  }

  .btn-close {
    background: #00a6cb;
    /* Action */
    border: 1px solid #00a6cb;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 5px 15px;
    display: inline-block;
    color: white;
  }
  .icon {
    display: inline-block;
    width: 30px;
    height: 30px;
    line-height: 1.875rem;
    text-align: center;
    vertical-align: middle;
  }
  .autocomplete {
    position: relative;

    .bottom-focus {
      content: '';
      width: calc(100% - 130px);
      height: 2px;
      background-color: transparent;
      position: absolute;
      bottom: -13px;
      left: 35px;

      @media (max-width: 1400px) {
        bottom: -18px;
      }
      @media (max-width: 1199px) {
        bottom: -10px;
      }
    }
    input[type='text']:focus ~ .bottom-focus {
      background-color: $primary-color2;
    }
  }
  input[type='text'] {
    width: calc(100% - 130px);
    display: inline-block;
    color: #fff;
    vertical-align: middle;
    font-style: normal;
    font-weight: normal;
    font-size: 1.5rem;
    line-height: 1.5rem;
    border-color: transparent;
    background-color: transparent;
    padding: 5px 10px;

    &::placeholder {
      color: #d1d1de;
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }

  input[type='submit'] {
    background-color: DodgerBlue;
    color: #fff;
    cursor: pointer;
  }

  .search-item-box {
    position: relative;

    &:after {
      content: '';
      width: calc(100% - 55px);
      height: 3px;
      position: absolute;
      bottom: -11px;
      left: 45px;
      background-color: $primary-color2;

      @media (max-width: 1199px) {
        bottom: -19px;
      }
      @media (max-width: 991px) {
        bottom: -9px;
      }
    }

    input[type='text']:focus ~ .suggest_results {
      height: auto;
      overflow: inherit;
      padding: 20px 0 15px;
      @include placeholder {
        color: #c2c2d6;
      }
    }

    .suggest_results {
      background-color: #000000;
      position: absolute;
      width: 100%;
      top: calc(100% + 10px);
      height: 0px;
      overflow: hidden;
      @include transition();

      &::before,
      &::after {
        content: '';
        width: 100%;
        background-color: #000;
        position: absolute;
        left: -99%;
        bottom: 0;
        height: 100%;
        @media (max-width: 991px) {
          height: calc(100% + 50px);
        }
      }
      &:after {
        left: auto;
        right: -99%;
      }

      li {
        padding-left: 45px;
        margin-bottom: 5px;

        a {
          font-family: $primary-font;
          font-style: normal;
          font-weight: normal;
          font-size: 1.5rem;
          line-height: 2rem;
          color: #fff;

          &:hover {
            color: $primary-color2;
          }
        }
      }
    }
  }
}
</style>
